import React, { Fragment } from 'react';
import { Transition, TransitionGroup } from 'components';
import css from './carousel-text.scss';

export function CarouselText({ children, current, className }) {
  return (
    <div className={[css.wrap, className].join(' ')}>
      <div className={css.placeholder}>{children}</div>
      <TransitionGroup component={null}>
        { children.filter(Boolean).filter((item, index) => current == index ).map(item =>
          <Transition key={item.props.id} classNames={css.locals} timeout={2000}>
            <div className={css.item}>
              { item }
            </div>
          </Transition>
        ) }
      </TransitionGroup>
    </div>
  );
}
